import * as Yup from 'yup';

export const firstNameSchema = Yup.string()
  .trim()
  .min(1, 'Too short')
  .max(50, 'Too long')
  .required('First name is required');

export const lastNameSchema = Yup.string()
  .trim()
  .min(1, 'Too short')
  .max(50, 'Too long')
  .required('Last name is required');

export const companyNameSchema = Yup.string()
  .min(3, 'Too short')
  .max(50, 'Too long')
  .required('Company name is required');

export const companyRoleSchema = Yup.string()
  .min(3, 'Too short')
  .max(50, 'Too long')
  .required('Company role is required');

export const emailSchema = Yup.string()
  .email('Must be a valid email')
  .matches(
    /^.*@(?!(gmail|yahoo|aol|hotmail|live)\.)/i,
    'Free email addresses are not allowed. Use the company email instead.'
  )
  .required('Email is required');

export const passwordSchema = Yup.string()
  .min(6, 'Password must be at least 6 characters')
  .required('Password is required');

export const repeatPasswordSchema = Yup.string()
  .oneOf(
    [Yup.ref('password'), null],
    'Password confirmation must match the password'
  )
  .required('Password confirmation is required');

export const requiredSchema = (message: string) =>
  Yup.string().required(message);
